import { render, staticRenderFns } from "./PlanDeliveryButton.vue?vue&type=template&id=20feeb71&scoped=true"
import script from "./PlanDeliveryButton.vue?vue&type=script&lang=js"
export * from "./PlanDeliveryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20feeb71",
  null
  
)

export default component.exports